<template>
    <b-tabs v-model="currentTab" content-class="mt-3">
        <b-tab :title="$t('General')">
            <b-form @keydown="form.onKeydown($event)" @submit.prevent="handleSubmit">
                <b-form-group
                        :invalid-feedback="form.errors.get('type')"
                        :label="$t('Type')"
                        :state="form.errors.has('type') ? false : null"
                        label-for="type"
                >
                    <b-form-select
                            id="type"
                            ref="typeField"
                            v-model="form.type"
                            :options="elementTypes"
                            :state="form.errors.has('type') ? false : null"
                            autofocus
                            name="type"
                    />
                </b-form-group>

                <b-form-group
                        :invalid-feedback="form.errors.get('name')"
                        :label="$t('Name')"
                        :state="form.errors.has('name') ? false : null"
                        label-for="name"
                >
                    <b-form-input
                            id="name"
                            v-model="form.name"
                            :state="form.errors.has('name') ? false : null"
                            name="name"
                    />
                </b-form-group>

                <element-fields :form="form" />

                <subtraction-mode-select v-model="form.subtraction_mode" />

                <div class="text-right">
                    <b-button :disabled="form.busy" type="submit" variant="primary">
                        {{ form.id ? $t('Save') : $t('Create') }}

                        <b-spinner v-show="form.busy" small />
                    </b-button>
                </div>
            </b-form>
        </b-tab>

        <b-tab :title="$t('Walls')">
          <walls-tree-select
              v-model="form.walls"
              :api-url-override="`/api/element/${value.id}/walls`"
              :errors="form.errors"
              :project-id="+projectId"
              :select-all-label="null"
              :disabled-function="true"
          />
        </b-tab>

        <b-tab :title="$t('Services')">
            <services-select
                    v-model="form.services"
                    :api-url="form.id ? `/api/elements/${form.id}/services` : null"
                    :multipliers="servicesMultipliers"
                    :project-id="projectId"
                    @input="$emit('input', form.data())"
            />
        </b-tab>
    </b-tabs>
</template>
<script>
import {ELEMENT_TYPES} from '@/constants';
import Form from 'vform';
import FloorSelect from '@/components/selects/ResourceSelect';
import ServicesSelect from '@/components/ServicesSelect';
import ELEMENTS_FIELDS_LOOKUP from '@/constants/elements_fields_lookup';

import {sortBy} from 'lodash';
import ElementFields from "@/components/elements/ElementFields";
import TreeView from "@/components/TreeView";
import SubtractionModeSelect from "@/components/selects/SubtractionModeSelect";
import WallsTreeSelect from "@/components/selects/WallsTreeSelect.vue";

export default {
  name: 'ElementForm',
  components: {WallsTreeSelect, SubtractionModeSelect, TreeView, ElementFields, ServicesSelect, FloorSelect},
  props: {
    value: {
      type: Object,
      default: null,
    },
    projectId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      form: new Form(this.value),
      walls: [],
      pendingWalls: false,
      currentTab: this.$route.query.currentTab || 0,
    };
  },
  computed: {
    type() {
      return this.form.type
    },
    apiUrl() {
      return `/api/projects/${this.projectId}/elements`;
    },

    elementTypes() {
      let elements = Object.keys(ELEMENT_TYPES).map(key => {
        return {
          value: ELEMENT_TYPES[key],
          text: this.$t(ELEMENT_TYPES[key]),
        };
      });

      return sortBy(elements, 'text')
    },

    fieldsLookup() {
      return ELEMENTS_FIELDS_LOOKUP[this.form.type] || [];
    },

    servicesMultipliers() {
      return this.fieldsLookup.filter(item => item.append === 'm');
    }
  },
  watch: {
    value: function (val) {
      this.form = new Form(val)
    },
  },
  methods: {
    async handleCreate() {
      let {data} = await this.form.post(this.apiUrl);
      this.$emit('created', data);
    },

    async handleSubmit() {
      if (this.form.busy) {
        return;
      }

      try {
        if (this.value.id) {
          await this.form.put(this.apiUrl + `/${this.value.id}`);
          this.$emit('input', this.form.data());
        } else {
          let {data} = await this.form.post(this.apiUrl);
          this.$emit('created', data);
        }

        this.savedToast();

        this.$refs.typeField.$el.focus();
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
    .input-group-text {
        width: 50px;
    }
</style>
